// extracted by mini-css-extract-plugin
module.exports = {"choice":"Choice_choice__3Xeaj","content":"Choice_content__2rwv1","placeholder":"Choice_placeholder__VXxFa","arrow":"Choice_arrow__fGi8X"};